import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { BillToModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";
import ChangeCustomerState from "@store/Store/Pages/ChangeCustomer/ChangeCustomerState";
import removeBookendCommasAndSpaces from "@store/utilities/removeBookendCommasAndSpaces";
import { Draft } from "immer";

const initialState: ChangeCustomerState = {
	selectedShipToAddress: "",
};

const hasAlphanumeric = (addressField: string) => {
    return /[a-zA-Z0-9]/.test(addressField);
}

const reducer = {
	"Store/Pages/ChangeCustomer/SetCurrentSelectedShipTo": (
        draft: Draft<ChangeCustomerState>,
        action: { currentSelectedShipTo: ShipToModel},
    ) => {
        const fullAddress = action.currentSelectedShipTo.fullAddress;
        const label = action.currentSelectedShipTo.label;
        if (action.currentSelectedShipTo) {
            if (hasAlphanumeric(fullAddress)) {
                draft.selectedShipToAddress = removeBookendCommasAndSpaces(fullAddress);
            } else if (hasAlphanumeric(label)) {
                draft.selectedShipToAddress = removeBookendCommasAndSpaces(label);
            } else {
                draft.selectedShipToAddress = "";
            }
        }
    },
	"Store/Pages/ChangeCustomer/SetCurrentSelectedBillTo": (
        draft: Draft<ChangeCustomerState>,
        action: { currentSelectedBillTo: BillToModel},
    ) => {
        if (action.currentSelectedBillTo) {
            draft.currentSelectedBillTo = action.currentSelectedBillTo;
        }
    },
};

const changeCustomerReducer = createTypedReducerWithImmer(initialState, reducer);
export default changeCustomerReducer;
